import { CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  return true;
};

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { RoleService } from '../services/helper/role-handling-helper';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard extends KeycloakAuthGuard {

  userRoles: string[] = [];
  
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private roleService: RoleService
  ) {
    super(router, keycloak);
  }
  
  async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
      });
    }

    const requiredRoles = route.data['roles'];
    let granted: boolean = false;

    if(!requiredRoles || requiredRoles.length === 0) {
      granted = true;
    } else {
      for (const requiredRole of requiredRoles) {
        if(this.roleService.isRole(requiredRole)) {
          granted = true;
          break;
        }
      }
    }

    if(granted === false) {
      this.router.navigate(['/']);
    }

    return this.authenticated;
  }
}
